<template>
  <PullRefresh
    v-model="refreshLoading"
    success-text="刷新成功"
    @refresh="onRefresh"
    :disabled="dialogVisible || disablePull"
  >
    <div
      class="expand_warp bg_contain"
      :class="{
        light: actInfo.style === 0,
        dark: actInfo.style === 1
      }"
      :style="{
        backgroundImage: `url(${actInfo.background})` 
      }"
    >
      <div class="nav">
        <div class="nav_back" @click="handleNativeBack">
          <i class="iconfont yw-xiangzuo"></i>
        </div>
        <div class="nav_title">{{ actInfo.name }}</div>
        <div class="nav_rule" @click="handleGoRule">
          活动规则
        </div>
      </div>
      <template v-if="isGoing">
        <!-- 顶部活动图 -->
        <div
          class="header_bg bg_contain"
          :style="{
            backgroundImage: `url(${actInfo.banner})` 
          }"
        >

        </div>
        <!-- 在玩游戏 -->
        <div
          v-if="actInfo.collectActivityGameTabList.length"
          class="playing_games sub_wrap"
        >
          <div
            class="playing_icon"
            :style="{
              backgroundImage: `url(${CDN_URL_1}/box_expandUser/tag.png)` 
            }"
          >
            在玩
          </div>
          <div class="playing_wrap">
            <div
              class="playing_item bg_contain"
              v-for="it in actInfo.collectActivityGameTabList"
              :key="it.gameId"
              :style="{
                backgroundImage: `url(${it.icon})`
              }"
              @click="handleScollTo(it)"
            >
            </div>
          </div>
        </div>
        <!-- 游戏 & 礼包 -->
        <div
          class="games_gifts sub_wrap"
          @touchstart="disablePull = true"
          @touchend="disablePull = false"
        >
          <div
            class="game_item"
            :class="{ ['game_pivot_' + game.gameId]: !!game.gameId }"
            v-for="game in gameGiftList"
            :key="game.gameId"
          >
            <div class="game_wrap ch_wrap">
              <div
                class="game_img bg_contain"
                :style="{
                  backgroundImage: `url(${game.icon})`
                }"
              >
              </div>
              <div class="game_info">
                <div class="game_title">{{ game.gameName }}</div>
                <div class="game_desc van-ellipsis scale09">{{ game.price }}</div>
              </div>
              <div
                class="game_btn btn_game bg_contain"
                :style="{
                  backgroundImage: `url(${CDN_URL_1}/box_expandUser/btn_${styleMode}.png)`
                }"
                @click="onSkipDetail(game)"
              >下载/查看游戏</div>
            </div>
            <div
              class="gift_wrap ch_wrap"
              v-for="gift in game.collectActivityGameGiftVoList"
              :key="gift.activityGiftId"
            >
              <div
                class="gift_img bg_contain"
                :style="{
                  backgroundImage: `url(${gift.giftIcon})`
                }"
              >
              </div>
              <div class="gift_info">
                <div class="gift_title">{{ gift.giftName }}</div>
                <div class="gift_desc van-ellipsis scale09">礼包内容：{{ gift.desc }}</div>
                <div class="gift_desc van-ellipsis scale09">领取条件：{{ getCondition(gift.drawCondite, gift.condite) }}</div>
              </div>
              <div class="gift_right">
                <div
                  class="gift_btn btn_gift btn_gift_shadow"
                  :class="{ gift_received: gift.drawStatus === 1 }"
                  @click="handleReceive(gift, game)"
                >
                  {{ gift.drawStatus === 1 ? '已领取' : '领取' }}
                </div>
                <div class="gift_receive_status scale09_center">
                  {{ gift.refresh === 1 ? '限领一次' : '每日刷新' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="notice_wrap">
          {{ actInfo.activityStatus === 2 ? '活动已结束' : `活动将于 ${actInfo.startTime} 开始` }}
        </div>
      </template>
    </div>
    <ActivityDialog
      :title="dialogTitle"
      :visible="dialogVisible"
      hideCancel
      :hideSure="hideConfirmCodes.includes(dialogType)"
      :sureText="sureText"
      @click-sure="onSureDialog"
      @click-cancel="onHideDialog"
      :herderStyle="{ background: '#FFB503' }"
      :sureStyle="{ background: '#FF9916' }"
    >
      <template v-slot:main>
        <div v-if="dialogType" class="dialog">
          <p class="dialog_desc" v-html="conditionText">
          </p>
          <div
            v-if="showProgressCodes.includes(dialogType)"
            class="progress"
          >
            <p class="progress_text">当前进度</p>
            <p
              class="progress_percentage"
              :class="{ left0: percentage === 0 }"
              :style="{ width: percentage + '%' }"
            ></p>
            <p
              v-if="percentage < 100"
              class="amount transformX50"
              :style="{
                left: (percentage === 0 ? 2 : percentage) + '%',
                top: percentage > 90 ? '-22px' : '8px'
              }"
            >
              {{ amount }}
            </p>
            <p
              v-if="percentage < 100"
              class="amount transformX50_1"
              :style="{
                right: 0,
                top: '8px'
              }"
            >
              {{ maxAmount }}
            </p>
          </div>
        </div>
      </template>
    </ActivityDialog>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import ActivityDialog from "@/components/btBox/ActivityDialog";
import {
  setPageTitle,
  jumpToNative,
  clickRightTxt,
  setRightTxtColor,
  setRightTxt,
  callHideToolbar,
  onGoBack,
  toLogin,
  getUserInfo,
  signInEventTrack
} from "@/bridge/AppJsBridge";
import {
  expandUserActivityInfoApi,
  expandUserActivityGiftListApi,
  expandUserActivityDrawGiftApi
} from '@/apis/btBoxActivity'
import { PullRefresh } from "vant";
import { CDN_URL_1 } from "@/config";
import { Toast } from "vant";
import EventTrack from '@/mixins/eventTrack'
const StatusEnum = {
  90204 : '未查询到游戏记录',
  90205 : '首次进入该游戏时间不在活动时间范围内',
  90208 : '角色等级不满足条件',
  90209 : '每日付费不满足条件',
  90210 : '活动期间付费不满足条件',
  90211 : '累计登录盒子天数不满足条件',
  90212 : '连续登录盒子天数不满足条件',
}
export default {
  components: {
    PullRefresh,
    ActivityDialog
  },
  mixins: [EventTrack],
  data () {
    return {
      CDN_URL_1,
      refreshLoading: false,
      actInfo: {
        activityStatus: 1, // 活动状态 0-未开始 1-进行中 2-已结束
        startTime: "", // 开始时间 活动未开始会返回
        name: '', // 活动名称
        style: 0, // 0-浅色背景主题 1-深色背景主题
        background: `${CDN_URL_1}/box_expandUser/bg_light.png`, // 背景图
        banner: '', // 头图
        collectActivityGameTabList: [], // 在玩游戏信息
      },
      gameGiftList: [],
      giftInfo: {}, // 最近领取的礼包信息
      gameInfo: {},
      receiveLoading: false,
      dialogVisible: false,
      disablePull: false,
      dialogTitle: '不满足领取条件',
      sureText: '222',
      dialogType: 1,
      hideConfirmCodes: [90211, 90212],
      showProgressCodes: [90208, 90209, 90210, 90211, 90212], // 需要展示进度条的 codes
      percentage: 40,
      amount: 100,
      maxAmount: 0,
      conditionText: '', // 不满足条件的desc
    }
  },
  beforeRouteEnter: (to, from, next) => {
    callHideToolbar(true)
    next()
  },
  beforeRouteLeave: (to, from, next) => {
    callHideToolbar(false)
    next()
  },
  computed: {
    // 活动是否进行当中
    isGoing () {
      return this.actInfo.activityStatus === 1
    },
    activityId () {
      return this.$route.query.id
    },
    activityInfo () {
      return {
        activity_id: this.activityId,
        activity_name: this.actInfo.name
      }
    },
    styleMode () {
      return this.actInfo.style === 0 ? 'light' : 'dark'
    }
  },
  created () {
    // inithandler()
    this.getAppToken()
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.fetchInfo().finally(() => {
        this.eventTrack({
          event: "lxls_page",
          event_field: JSON.stringify({
            ...this.activityInfo,
          }),
        })
      })
      this.fetchGameGiftList()
    },
    onRefresh () {
      this.init()
      setTimeout(() => {
        this.refreshLoading = false
      }, 500)
    },
    handleNativeBack () {
      onGoBack()
    },
    // 获取活动信息
    fetchInfo () {
      return expandUserActivityInfoApi({ activityId: this.activityId }).then(res => {
        this.actInfo = res.data
      }).catch(err => {
        const { response } = err
        if (response) {
            const { data } = response
            if (data && data.code === 401) {
              toLogin("/loginKey/LoginByKeyPhoneActivity")
            }
          }
      })
    },
    // 获取游戏&礼包列表
    fetchGameGiftList () {
      expandUserActivityGiftListApi({ activityId: this.activityId }).then(res => {
        this.gameGiftList = res.data || []
      })
    },
    getCondition (type, value) {
      const map = {
        0: '活动期间注册游戏可领',
        1: `新注册角色达${value}级可领`,
        2: `今日充值${value}元可领`,
        3: `活动期间充值${value}可领`,
        4: `累计登录盒子${value}天可领`,
        5: `连续登录盒子${value}天可领`,
      }
      return map[type]
    },
    handleReceive (gift, game) {
      if (this.receiveLoading || gift.drawStatus === 1) return
      this.eventTrack({
        event: "lxls_draw_button",
        event_field: JSON.stringify({
          ...this.activityInfo,
          gift_id: gift.giftId,
          gift_name: gift.giftName,
          type: gift.drawCondite
        }),
        appkey: game.gameId,
        appName: game.gameName,
      })
      this.receiveLoading = true
      this.giftInfo = gift
      this.gameInfo = {
        gameId: game.gameId,
        gameName: game.gameName,
      }
      expandUserActivityDrawGiftApi({
        activityGiftId: gift.activityGiftId
      })
        .then(res => {
          const { cdk } = res.data
          if (cdk === null) {
            // 礼包码为null时表示生成错误
            this.openDialog(-1, '1/1')
          } else {
            this.openDialog(1, '1/1')
          }
          // EVENT_TRACK_5/7
          this.eventTrack({
            event: "lxls_draw_success_pop",
            event_field: JSON.stringify({
              ...this.activityInfo,
              gift_id: gift.giftId,
              gift_name: gift.giftName,
              type: gift.drawCondite,
              pop_type: cdk === null ? 1 : 0
            }),
            appkey: game.gameId,
            appName: game.gameName,
          })
          this.fetchGameGiftList()
        })
        .catch((e) => {
          const codes = Object.keys(StatusEnum).map(v => v * 1)
          if (!codes.includes(e.code)) {
            Toast.fail({
              message: e.msg || e.message,
              duration: 2000,
            });
          } else {
            this.openDialog(e.code, e.msg)
          }
          console.log(e)
        })
        .finally(() => {
          this.receiveLoading = false
        })
      // EVENT_TRACK_4
    },
    // code 相关值
    openDialog (type, val = '') {
      this.dialogVisible = true
      this.dialogType = type
      const [present, target] = val.split('/')
      this.dialogTitle = "不满足领取条件"
      if (this.showProgressCodes.includes(type)) {
        this.percentage = present / target * 100
        this.amount = present
        this.maxAmount = target
        this.eventTrack({
          event: "lxls_draw_faile_pop_condit",
          event_field: JSON.stringify({
            ...this.activityInfo,
            gift_id: this.giftInfo.giftId,
            gift_name: this.giftInfo.giftName,
            type: this.giftInfo.drawCondite,
            current: present,
            target,
          }),
          appkey: this.gameInfo.gameId,
          appName: this.gameInfo.gameName,
        })
      }
      if (type === 90211) {
        this.sureText = "我知道了"
        this.conditionText = `活动期间累计登录盒子达${target}天
          即可领取礼包`
      }
      if (type === 90212) {
        this.sureText = "我知道了"
        this.conditionText = `活动期间连续登录盒子达${target}天
          即可领取礼包`
      }
      if (type === 90204) {
        this.sureText = "下载游戏"
        this.conditionText = `未查询到游戏记录
          在活动时间内下载游戏并用此账号创角即可领取礼包`
      }
      if (type === 90205) {
        this.sureText = "我知道了"
        this.conditionText = `您首次进入该游戏时间
          不在活动时间范围内
          无法领取礼包`
      }
      if (type === 90208) {
        this.sureText = "去完成"
        this.conditionText = `角色达${target}级
          即可领取礼包`
      }
      if (type === 90209) {
        this.sureText = "去完成"
        this.conditionText = `今日在游戏内充值金额达到${target}元即可领取礼包`
      }
      if (type === 90210) {
        this.sureText = "去完成"
        this.conditionText = `活动期间充值金额达到${target}
          即可领取礼包`
      }
      if (type === 1) {
        this.dialogTitle = "领取成功"
        this.sureText = '查看礼包码'
        this.conditionText = `礼包已存放在
        【我的】-【我的礼包】-【活动礼包】`
      }
      if (type === -1) {
        this.dialogTitle = "提示"
        this.sureText = '联系客服'
        this.conditionText = `兑换码生成错误，请联系客服领取备用码`
      }
      if ([90204, 90205].includes(type)) {
        this.eventTrack({
          event: "lxls_draw_faile_pop",
          event_field: JSON.stringify({
            ...this.activityInfo,
            gift_id: this.giftInfo.giftId,
            gift_name: this.giftInfo.giftName,
            type: this.giftInfo.drawCondite,
          }),
          appkey: this.gameInfo.gameId,
          appName: this.gameInfo.gameName,
        })
      }
    },
    onSureDialog () {
      const code = this.dialogType
      if ([90204, 90208, 90209, 90210].includes(code)) {
        console.log('给我去下载游戏')
        this.onSkipDetail({ gameId: this.gameInfo.gameId }, true)
      }
      if ([90205].includes(code)) {
        this.onHideDialog()
      }
      if ([1, -1].includes(code)) {
        this.eventTrack({
          event: "lxls_draw_success_pop_button",
          event_field: JSON.stringify({
            ...this.activityInfo,
            gift_id: this.giftInfo.giftId,
            gift_name: this.giftInfo.giftName,
            type: this.giftInfo.drawCondite,
            button_type: code === 1 ? 0 : 1
          }),
          appkey: this.gameInfo.gameId,
          appName: this.gameInfo.gameName,
        })
        // 用 1 表示没有错误码
        if (code === 1) {
          this.onClickGiftCdk()
        }
        if (code === -1) {
          this.onRelationServer()
        }

      }
      if ([90204].includes(code)) {
        this.eventTrack({
          event: "lxls_draw_faile_pop_button",
          event_field: JSON.stringify({
            ...this.activityInfo,
            gift_id: this.giftInfo.giftId,
            gift_name: this.giftInfo.giftName,
            type: this.giftInfo.drawCondite
          }),
          appkey: this.gameInfo.gameId,
          appName: this.gameInfo.gameName,
        })
      }
      if ([90208, 90209, 90210].includes(code)) {
        this.eventTrack({
          event: "lxls_draw_faile_pop_to_complete_button",
          event_field: JSON.stringify({
            ...this.activityInfo,
            gift_id: this.giftInfo.giftId,
            gift_name: this.giftInfo.giftName,
            type: this.giftInfo.drawCondite,
            current: this.amount,
            target: this.maxAmount
          }),
          appkey: this.gameInfo.gameId,
          appName: this.gameInfo.gameName,
        })
      }
      this.onHideDialog()
    },
    onHideDialog () {
      this.dialogVisible = false;
    },
    // 跳转礼包
    onClickGiftCdk() {
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: 2, // 2 -> BT盒子活动 3-> 玩心盒子活动
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr)
      this.onHideDialog()
    },
    // 联系客服
    onRelationServer() {
      this.$router.push({
        name: `box.customerService`,
      });
    },
    // 游戏详情 
    onSkipDetail(it, isPop = false){
      if (!isPop) {
        this.eventTrack({
          event: "lxls_download_button",
          event_field: JSON.stringify({
            ...this.activityInfo,
          }),
          appkey: it.gameId,
          appName: it.gameName,
        })
      }
      const data = {
        routePath: "/main/game/GameDetailActivity",
        fromPageType: 34,
        extraParams: it.gameId
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    handleGoRule () {
      this.eventTrack({
        event: "lxls_rule_button",
        event_field: JSON.stringify({
          ...this.activityInfo,
        }),
      })
      this.$router.push({
        name: `box.btActRule`,
        params: {
          type: 12 // type 根据 bt 管理端配置而来
        },
      });
    },
    // 点击在玩游戏 icon，滚动到
    handleScollTo (it) {
      const ele = document.querySelector('.game_pivot_' + it.gameId)
      if (!ele) return
      // EVENT_TRACK_2
      this.eventTrack({
        event: "lxls_play_game_tab",
        event_field: JSON.stringify({
          ...this.activityInfo,
        }),
        appkey: it.gameId,
        appName: it.gameName,
      })
      ele.scrollIntoView({
        top: 10,
        left: 0,
        behavior: "smooth"
      })
    },
    // 设置顶部内容
    setHeaderContent(){
      setRightTxtColor("#ff6600");
      // EVENT_TRACK_1 需要客户端
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.$router.push({
          name: `box.actPlaceRule`,
          params: {
            type: 648,
            activeRule: this.pageData.activeRule,
          },
        });
        this.eventTrack({
          event: 'activity_rule',
          event_field: JSON.stringify({
            activity_name: this.pageData.activeName, 
            activity_id: this.activeId
          }),
        })
      });
    },
    getActivityInfo () {
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
.light {
  color: #3c4668;

  .nav_title {
    color: #000;
  }
  .btn_game {
    color: #Fff;
    background-color: #5682FF;
  }
  .btn_gift {
    color: #5682FF;
    background-color: #fff;
    // box-shadow: 0.01px 0.35px 4.51px 0px #8cb3ff; 
  }
  .gift_received {
    box-shadow: none !important;
    opacity: .7;
  }
  .gift_wrap {
    // background: #f3f6fe;
    border-radius: 8px;
  }
  .sub_wrap {
    background-color: #fff;
  }
  .ch_wrap {
    background: #f3f6fe;
  }
  .gift_receive_status {
    color: #DE482B;
  }
  .games_gifts {
    background-color: #fff;
  }
}

.dark {
  color: #fff;
  .btn_gift {
    background-color: #FF7442;
    color: #fff;
  }
  .gift_received {
    background-color: #919191;
  }
  .game_btn {
    color: #2F0600;
  }
  .header_bg {
    border: 2px #805A3F solid;
  }
  .sub_wrap {
    border: 2px #805A3F solid;
    background-color: #0f0c0b;
  }
  .ch_wrap {
    background: #272421;
  }
  .gift_receive_status {
    color: #FF7442;
  }
}

.notice_wrap {
  width: 100%;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.expand_warp {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  padding: 8px;
  padding-top: 32px;
  transition: 0.2s all ease;
}

.content_wrap {
  display: flex;
  flex-direction: column;
}

.nav {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  height: 32px;
  color: #fff;
  .nav_back {
    width: 70px;
    height: 20px;
    display: flex;
    align-items: center;
  }
  .nav_title {
    flex: 1;
    text-align: center;
    font-size: 18px;
  }
  .nav_rule {
    width: 70px;
    font-size: 14px;
    text-align: right;
  }
}

.header_bg {
  width: 100%;
  height: 92px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.playing_games {
  position: relative;
  padding: 10px 20px 10px 42px;
  margin-bottom: 12px;
  .playing_icon {
    position: absolute;
    top: -2px;
    left: 8px;
    width: 28px;
    height: 56px;
    background-size: contain;
    text-align: center;
    padding: 4px;
    font-size: 12px;
    color: #fff;
    font-weight: 700;
    line-height: 1.25;
    margin-right: 9px;
  }
  .playing_wrap {
    display: flex;
    flex-wrap: wrap;
    .playing_item {
      width: 48px;
      height: 48px;
      margin-bottom: 6px;
    }
    .playing_item + .playing_item {
      margin-left: 10px;
    }
    .playing_item:nth-child(5n + 1) {
      margin-left: 0;
    }
  }
}

.games_gifts {
  flex: 1;
  padding: 14px 10px;
  height: 0;
  overflow: auto;
  .game_item {
    margin-bottom: 12px;
    .game_wrap {
      display: flex;
      align-items: center;
      border-radius: 7px;
      padding: 10px;
      margin-bottom: 6px;
      .game_img {
        width: 59px;
        height: 59px;
        border-radius: 10px;
        margin-right: 8px;
      }
      .game_info {
        flex: 1;
        .game_title {
          font-weight: 700;
          font-size: 15px;
          margin-bottom: 16px;
        }
        .game_desc {
          font-size: 12px;
        }
      }
      .game_btn {
        font-size: 13px;
        height: 32px;
        width: 97px;
        text-align: center;
        line-height: 32px;
        border-radius: 16px;
      }
    }
    .gift_wrap {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 8px 40px 8px 14px;
      border-radius: 7px;
      .gift_img {
        width: 44px;
        height: 44px;
        border-radius: 10px;
        margin-right: 10px;
        flex-shrink: 0;
      }
      .gift_info {
        display: flex;
        flex-direction: column;
        flex: 1;
        width: 0;
        .gift_title {
          font-weight: 700;
          font-size: 14px;
          margin-bottom: 4px;
        }
        .gift_desc {
          font-size: 12px;
          white-space: nowrap;
        }
      }
      .gift_right {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 71px;
        text-align: center;
        font-size: 15px;
        display: flex;
        flex-direction: column;
        // align-items: center;
        margin-left: 4px;
        flex-shrink: 0;
        .gift_btn {
          border-radius: 15px;
          height: 30px;
          line-height: 30px;
        }
        .gift_receive_status {
          font-size: 12px;
          line-height: 1.2;
          margin: 4px auto 0;
        }
      }
    }
    .gift_wrap + .gift_wrap {
      margin-top: 6px;
    }
  }
}

.sub_wrap {
  border-radius: 8px;
}

.bg_contain {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}



// 弹框相关样式
.dialog {
  .dialog_desc {
    text-align: center;
    white-space: pre-line;
  }
  .progress {
    height: 8px;
    border-radius: 8px;
    border: 1px solid #c73534;
    width: 80%;
    margin: 40px auto 50px;
    position: relative;
    .progress_percentage {
      height: 6px;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      background: linear-gradient(90deg,#ff756a 0%, #ffb46b 100%);
      border-radius: 6px;
    }
    .progress_percentage::before{
      content: ".";
      position: absolute;
      top: -4px;
      right: 0;
      color: #c73534;
    }
    .left0.progress_percentage::before {
      left: 0;
    }
    .progress_text {
      font-size: 12px;
      color: #747474;
      font-weight: 500;
      position: absolute;
      top: -22px;
      width: auto;
      left: 0;
    }
    .amount {
      font-size: 12px;
      color: #c73534;
      font-weight: 500;
      position: absolute;
      top: 8px;
      width: auto;
      margin-left: -10px;
    }
    .typeValue {
      font-size: 12px;
      color: #c73534;
      font-weight: 500;
      position: absolute;
      right: -10px;
      top: 8px;
      width: auto;
    }
  }
  .progress::before {
    content: ".";
    color: #c73534;
    position: absolute;
    top: 0px;
    right:0%;
  }
}
.transformX50 {
  transform: translateX(50%);
}
.transformX50_1 {
  transform: translateX(calc(50% - 1px));
}
.left0 {
  left: 0 !important;
}
</style>
